/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrderBatchResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type OrderBatchResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/batches/{batchId}
 */
export interface WithBatchItemRequestBuilder extends BaseRequestBuilder<WithBatchItemRequestBuilder> {
    /**
     * Returns one placement of an agency cart — the shared header as it stood, whether a signature was taken — with every vendor order it produced. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderBatchResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithBatchItemRequestBuilderGetQueryParameters> | undefined) : Promise<OrderBatchResponse | undefined>;
    /**
     * Returns one placement of an agency cart — the shared header as it stood, whether a signature was taken — with every vendor order it produced. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithBatchItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns one placement of an agency cart — the shared header as it stood, whether a signature was taken — with every vendor order it produced. Agency organizations only.
 */
export interface WithBatchItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithBatchItemRequestBuilderUriTemplate = "{+baseurl}/api/orders/batches/{batchId}{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithBatchItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithBatchItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderBatchResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
